<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("credits.detailsTitle") }}
      </p>
    </header>

    <section class="modal-card-body">
      <h2 class="has-text-centered">
        <b>{{ $t("credits.creditId") }}:</b> {{ credit._id }}
        <br />
        <b>{{ $t("credits.creditDateTime") }}:</b>
        {{
          moment
            .utc(credit.createdAt)
            .add(preferences.timezone, "h")
            .format("DD/MM/YY HH:mm")
        }}
      </h2>
      <br />

      <h1 class="subtitle has-text-centered">
        {{
          `${$t("common.value")}: ${payments.currencySymbol} ${formatMoney(
            credit.value
          )}`
        }}
      </h1>
      <br />

      <div class="columns">
        <div class="column">
          <b>
            <u>{{ $t("common.user") }}:</u>
          </b>
          <br />

          <b>{{ $t("common.id") }}:</b>
          {{ credit.user._id }}
          <br />

          <div v-if="permissions.seeStoreClientName">
            <p>
              <b>{{ $t("common.name") }}:</b>
              {{
                `${credit.user.personalInfo.name}${
                  permissions.seeStoreClientSurname
                    ? ` ${credit.user.personalInfo.surname}`
                    : ""
                }`
              }}
            </p>

            <p v-if="credit.user.personalInfo.socialName">
              <b>{{ $t("common.socialName") }}:</b>
              {{ credit.user.personalInfo.socialName }}
            </p>
          </div>

          <div v-if="permissions.seeStoreClientPersonalId">
            <b>{{ $t("common.personalId") }}:</b>
            {{ credit.user.personalInfo.personalId }}
            <br />
          </div>

          <div v-if="permissions.seeStoreClientCellphone">
            <b>{{ $t("common.cellphone") }}:</b>
            {{
              `${credit.user.personalInfo.countryCallingCode} ${credit.user.personalInfo.cellphone}`
            }}
            <br />
          </div>

          <div v-if="permissions.seeStoreClientEmail">
            <b>{{ $t("common.email") }}:</b>
            {{ credit.user.personalInfo.email }}
          </div>
        </div>

        <div class="column">
          <b>
            <u>{{ $t("common.store") }}:</u>
          </b>
          <br />
          <b>{{ $t("common.name") }}:</b> {{ credit.store.storeInfo.name }}
        </div>
      </div>
      <hr />

      <div class="columns">
        <div class="column">
          <b>
            <u>{{ $t("credits.implementedBy") }}:</u>
          </b>
          <br />

          <b>{{ $t("credits.account") }}:</b>
          {{
            credit.grantedBy.assignor === "onii"
              ? `${credit.grantedBy.adminAccount.name} (Onii)`
              : credit.grantedBy.assignor === "mq"
              ? `${credit.grantedBy.adminAccount.name} (MQ)`
              : credit.grantedBy.assignor === "merchant"
              ? `${credit.grantedBy.merchantAccount.ownerInfo.name} (Licenciado)`
              : "-"
          }}
          <br />

          <b>{{ $t("credits.creditReason") }}:</b>
          {{ credit.grantedBy.grantReason }}
          <br />
        </div>

        <div class="column">
          <b>
            <u>{{ $t("credits.royalties") }}:</u>
          </b>
          <br />

          <button
            class="button is-pulled-right"
            :class="
              credit.royalty.status === 'open'
                ? 'is-warning'
                : credit.royalty.status === 'paid'
                ? 'is-success'
                : credit.royalty.status === 'free'
                ? 'is-info'
                : '-'
            "
          >
            {{
              credit.royalty.status === "open"
                ? $t("credits.open")
                : credit.royalty.status === "paid"
                ? $t("credits.paid")
                : credit.royalty.status === "free"
                ? $t("credits.exempt")
                : "-"
            }}
          </button>

          <b>{{ $t("credits.percentage") }}:</b>
          {{ `${credit.royalty.percentage}%` }}
          <br />

          <b>{{ $t("common.value") }}:</b>
          {{ `${payments.currencySymbol}${formatMoney(credit.royalty.value)}` }}
          <br />

          <div v-if="credit.royalty.royaltyFree">
            <b>{{ $t("credits.exemptionReason") }}:</b>
            {{ credit.royalty.royaltyFreeReason }}
            <br />
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";

export default {
  props: ["credit"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments", "permissions", "preferences"])
  }
};
</script>
